/**
 * @author
 * David Rivera (jherax)
 * https://github.com/jherax
 */

/**
 * @private
 */
const ESCAPE_CHARS = /[.*+?=!:${}()|\-^[\]/\\]/g;

/**
 * @public
 * Escapes the special characters in the entry parameter, so that
 * it can be used as a pattern in a regular expression constructor.
 *
 * @param  {String} text: pattern to escape special characters
 * @return {String|Null}
 */
export default function escapeRegExp(text) {
  if (typeof text !== 'string') return null;
  return text.replace(ESCAPE_CHARS, '\\$&');
}
